module.exports = __webpack_public_path__ + "img/genshin.80cf8a4.png";